/**
 * Serviço para gerenciamento de perfil comercial da API Oficial
 */

import { apiService } from './api';
import { BusinessProfile, UpdateProfileData } from '../types/template';

class ProfileApiService {
  
  /**
   * Busca o perfil comercial de um número
   * @param phoneNumberId ID do número na Meta
   * @returns Perfil comercial
   */
  async getBusinessProfile(phoneNumberId: string): Promise<BusinessProfile> {
    const response = await apiService.get(`/official-api/profiles/${phoneNumberId}`);
    return response.data;
  }
  
  /**
   * Atualiza o perfil comercial de um número
   * @param phoneNumberId ID do número na Meta
   * @param data Dados para atualizar
   * @returns Perfil atualizado
   */
  async updateBusinessProfile(
    phoneNumberId: string,
    data: UpdateProfileData
  ): Promise<BusinessProfile> {
    const response = await apiService.patch(
      `/official-api/profiles/${phoneNumberId}`,
      data
    );
    return response.data;
  }

  /**
   * Faz upload de uma foto de perfil
   * @param phoneNumberId ID do número na Meta
   * @param file Arquivo de imagem
   * @returns URL da foto atualizada
   */
  async uploadProfilePicture(
    phoneNumberId: string,
    file: File
  ): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiService.post(
      `/official-api/profiles/${phoneNumberId}/picture`,
      formData
    );
    
    return response.data.profile_picture_url;
  }
}

export const profileApiService = new ProfileApiService();

